'use strict';

import {projectConfig} from '../project-info/projectConfig';
import { primaryOptions, subOptions } from '../project-info/serviceInfo';

const status_radio_props = primaryOptions;

const branch_radio_props = subOptions;

const disability_radio_props = [
  {label: 'Yes', value: true},
  {label: 'No', value: false},
];

const zone_radio_props = [
  {label: 'Yes', value: true},
  {label: 'No', value: false},
];

const deployment_radio_props = [
  {label: 'World War II', value: 'World War II'},
  {label: 'Korean War', value: 'Korean War'},
  {label: 'Vietnam War', value: 'Vietnam War'},
  {label: 'Dominican Republic', value: 'Dominican Republic'},
  {label: 'Lebanon', value: 'Lebanon'},
  {label: 'Grenada', value: 'Grenada'},
  {label: 'Panama', value: 'Panama'},
  {label: 'Gulf War', value: 'Gulf War'},
  {label: 'Somalia', value: 'Somalia'},
  {label: 'Haiti', value: 'Haiti'},
  {label: 'Bosnia', value: 'Bosnia'},
  {label: 'Kosovo', value: 'Kosovo'},
  {label: 'Afghanistan', value: 'Afghanistan'},
  {label: 'Iraq', value: 'Iraq'},
  {label: 'Other', value: 'Other'},
];

const military_props = {
  status_radio_props,
  branch_radio_props,
  disability_radio_props,
  zone_radio_props,
  deployment_radio_props,
};

const address_type_radio_props = [
  {label: 'United States', value: 'domestic'},
  {label: 'International', value: 'international'},
];

const gender_radio_props = projectConfig.validGenderOptions;

const personal_info_props = {
  address_type_radio_props,
  gender_radio_props,
};

const anon_radio_props = [
  {
    label: `Yes, I would like to make my profile public (name, chapter, service, activities, and profile image may be shared with other members on the ${projectConfig.name} website and app).`,
    value: false,
  },
  {
    label: `No, please keep my profile anonymous (I will not be able to post to feed and events, and will not be able to create events on the ${projectConfig.name} website and app).`,
    value: true,
  },
];

const anonymity_props = {
  anon_radio_props,
};

const sizes_radio_props = [
  {label: 'Mens Small', value: 'Mens Small'},
  {label: 'Mens Medium', value: 'Mens Medium'},
  {label: 'Mens Large', value: 'Mens Large'},
  {label: 'Mens X-Large', value: 'Mens X-Large'},
  {label: 'Mens XX-Large', value: 'Mens XX-Large'},
  {label: 'Mens 3XL', value: 'Mens 3XL'},
  {label: 'Mens 4XL', value: 'Mens 4XL'},
  {label: 'Womens Small', value: 'Womens Small'},
  {label: 'Womens Medium', value: 'Womens Medium'},
  {label: 'Womens Large', value: 'Womens Large'},
  {label: 'Womens X-Large', value: 'Womens XL'},
  {label: 'Womens XX-Large', value: 'Womens XX-Large'},
];

const radio_props = {
  sizes_radio_props,
};

export {
  military_props as MILITARY_PROPS,
  personal_info_props as PERSONAL_INFO_PROPS,
  anonymity_props as ANON_PROPS,
  radio_props as RADIO_PROPS,
};
